import { useQuery } from '@tanstack/react-query';

import { fetchLibrary } from '../sections/documents/documents-api';
import type { DocumentType } from '../sections/documents/documents-data';
import { toDocumentType } from '../sections/documents/documents-data';

export type RecentDocument = { id: string; name: string; type: DocumentType; previewUrl: string | null };

// Two rows of three on the dashboard card.
const SHOWN = 6;

export type RecentDocuments = { documents: RecentDocument[]; isLoading: boolean; error: Error | null };

export function useRecentDocuments(): RecentDocuments {
  const { data, isLoading, error } = useQuery({
    queryKey: ['documents', 'recent', 'dashboard'],
    queryFn: () => fetchLibrary({ view: 'recent', folderId: null, q: '', kind: null, sort: 'modified', dir: 'desc' }),
    staleTime: 60 * 1000,
  });
  const documents = (data?.items ?? [])
    .filter((entry) => entry.type === 'document')
    .slice(0, SHOWN)
    .map((entry) => ({
      id: entry.id,
      name: entry.name,
      type: toDocumentType(entry.kind),
      previewUrl: entry.previewUrl ?? null,
    }));
  return { documents, isLoading, error };
}
